/* eslint-disable */
import { fabric } from 'fabric';
import seatIcon from '@/assets/images/seat.svg';
import Event from '@/utils/Event';
const seatIconPath = "M892.65493333 276.61653333H828.75733333V144.45226667c0-28.94506667-20.20693333-52.4288-44.78293333-52.4288H236.7488c-24.576 0-44.78293333 23.48373333-44.78293333 52.4288v132.16426666h-63.8976V133.5296c0-55.15946667 41.50613333-99.9424 92.29653333-99.9424h579.9936c50.7904 0 92.29653333 44.78293333 92.29653333 99.9424v143.08693333z\" fill=\"#666666\" p-id=\"1662\"></path><path d=\"M885.5552 917.23093333h-74.27413333c-54.0672 0-97.75786667-45.8752-97.75786667-102.12693333v-1.09226667H307.2v1.09226667c0 56.25173333-44.2368 102.12693333-97.75786667 102.12693333H135.168c-54.0672 0-97.75786667-45.8752-97.75786667-102.12693333V354.16746667c0-56.25173333 38.77546667-102.12693333 92.29653334-102.12693334h68.8128c84.65066667 0 108.68053333 45.8752 108.68053333 102.12693334v185.68533333l405.77706667-0.54613333 0.54613333-185.1392c0-56.25173333 33.86026667-101.5808 103.76533333-101.5808h79.73546667c54.0672 0 86.8352 45.8752 86.8352 102.12693333v460.93653333c-0.54613333 55.7056-44.2368 101.5808-98.304 101.5808zM250.40213333 753.93706667h519.3728v38.22933333c0 26.76053333 20.20693333 48.60586667 45.32906667 48.60586667h66.62826667c25.12213333 0 45.32906667-21.84533333 45.32906666-48.60586667V377.6512c0-26.76053333-20.20693333-48.60586667-45.32906666-48.60586667H815.104c-25.12213333 0-45.32906667 21.84533333-45.32906667 48.60586667l-0.54613333 225.55306667-518.82666667 0.54613333V377.6512c0-26.76053333-20.20693333-48.60586667-45.32906666-48.60586667h-66.62826667c-25.12213333 0-45.32906667 21.84533333-45.32906667 48.60586667v414.5152c0 26.76053333 20.20693333 48.60586667 45.32906667 48.60586667h66.62826667c25.12213333 0 45.32906667-21.84533333 45.32906666-48.60586667v-38.22933333z";
const seatSelectIconPath = 'M971.3034725 378.11221625l0 479.06463375c0 41.85642094-33.93123469 75.78861562-75.78861562 75.78861562l-75.77710313 0c-41.85738094 0-75.78861562-33.93219375-75.78861562-75.78861562l0-24.003885L280.10938156 833.172965l0 24.003885c0 41.85642094-33.93219375 75.78861562-75.78861562 75.78861562l-75.77710313 0c-41.85642094 0-75.78861562-33.93219375-75.78861562-75.78861562L52.75504812 379.07156562c0-41.85642094 33.93219375-75.78861562 75.78861563-75.78861562l56.59011187 0c41.85642094 0 75.78861562 33.93219375 75.78861563 75.78861562L260.92239031 605.81863062l502.21373906 1e-8L763.13612937 378.11221625c0-41.85642094 33.93123469-75.78861562 75.78861563-75.78861562l56.59011187 0C937.37223781 302.32360062 971.3034725 336.25579437 971.3034725 378.11221625zM311.7679175 368.51872063L311.7679175 559.76985219l400.52268563 0L712.29060313 368.51872063c0-41.85642094 65.58976969-107.44715062 107.44715062-107.44715063l58.97601469 0L878.71376844 151.79110156c0-38.67809625-31.35538125-70.0325175-70.0325175-70.0325175L216.31935125 81.75858406c-38.67809625 0-70.0325175 31.35442125-70.0325175 70.0325175l0 109.2804675 58.03393312 0C246.17718781 261.07156906 311.7679175 326.66229875 311.7679175 368.51872063z';

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

const deepAssign = (to, from) => {
  for (const key in from) {
    if (
      !Object.prototype.hasOwnProperty.call(to, key)
      || !isObject(from[key])
    ) {
      to[key] = from[key];
      continue;
    }
    if (isObject(from[key])) {
      deepAssign(to[key], from[key]);
    }
  }
  return to;
};


// 排列类别
class SeatsChart {
  constructor(options) {
    this.options = deepAssign({
      seatStyle: {
        disabled: '#669999',
        active: '#ffa72b',
        inactive: '#e3e3e3',
      },
      seatConfig: {
        columns: 6, // 默认配置为6列
      },
      disabledPosition: [1, 2],
      seats: [],
    }, options);
    this.ctx = undefined;
    this.canvasRef = undefined;
    this.WIDTH = undefined;
    this.HEIGHT = undefined;
    this.ASILELENGTH = 50;
    this.seatLength = 50;
    this.seatHeight = 40;
    this.type = 0; // type = 0, 表示65座位. tpye = 1. 表示55座位
    this.columns = 6;
    this.selectedSeat = {};
    // 选中的position
    this.activePosition = [];
    // 禁止选中的position
    this.disabledPosition = [1, 2];
    this.allSeats = [];
    this.offsetX = 40; // x 轴上的offset
    this.offsetY = 20; // y 轴上的offset
    this.panning = false; // 是否拖动
    this.fixedTop = 0; // 标记当前top距离
    // this.seatPosition = [
    //   [1, 0, 0, 0, 0, 2],
    //   [3, 4, 5, 0, 6, 7],
    //   [8, 9, 10, 0, 11, 12],
    //   [13, 14, 15, 0, 16, 17],
    //   [18, 19, 20, 0, 21, 22],
    //   [23, 24, 25, 0, 26, 27],
    //   [28, 29, 30, 0, 31, 32],
    //   [33, 34, 35, 0, 0, 0],
    //   [36, 37, 38, 0, 39, 40],
    //   [41, 42, 43, 0, 44, 45],
    //   [46, 47, 48, 0, 49, 50],
    //   [51, 52, 53, 0, 54, 55],
    //   [56, 57, 58, 0, 59, 60],
    //   [61, 62, 63, 64, 65],
    // ];
  }

  init(elemId) {
    const elem = document.getElementById(elemId);
    elem.innerHTML = '';
    this.canvasRef = document.createElement('canvas');
    this.canvasRef.style.width = `${elem.clientWidth}px`;
    this.canvasRef.style.height = `${elem.clientHeight}px`;
    this.canvasRef.width = elem.clientWidth;
    this.canvasRef.height = elem.clientHeight;
    this.canvasRef.style.touchAction="none";
    this.canvasRef.style.userSelect='none';
    this.WIDTH = elem.clientWidth;
    this.HEIGHT = elem.clientHeight;
    elem.appendChild(this.canvasRef);
    this.ctx = new fabric.Canvas(this.canvasRef,{
       enablePointerEvents: true, // 强制开启指针事件
      enableTouchEvents: true,   // 强制开启触摸事件
      allowTouchScrolling: false, // 禁止触摸滚动（避免冲突）
      selection: false,           // 允许选中
      enableRetinaScaling: true  // 适配S25高分辨率屏
    });
     // this.ctx.selection = false;

    const canvas= this.ctx;
    // 4. 修复5.5.2版本触摸事件兼容问题（核心补丁）
    (function fixFabric5Touch(canvas) {
      // 覆盖fabric原生触摸处理，适配三星S25
      canvas.__onTouchStart = canvas._onTouchStart;
      canvas._onTouchStart = function(e) {
        e.preventDefault(); // 阻止浏览器默认手势（S25关键）
        // 转换触摸坐标为画布内部坐标
        const touch = e.touches[0];
        const rect = canvas.upperCanvasEl.getBoundingClientRect();
        const pointer = {
          x: (touch.clientX - rect.left) * (canvas.width / rect.width),
          y: (touch.clientY - rect.top) * (canvas.height / rect.height)
        };
        // 手动触发fabric的mouse:down事件
        canvas.fire('mouse:down', {
          pointer: pointer,
          e: e
        });
        // 调用原生方法
        this.__onTouchStart(e);
      };

      // 确保对象可响应事件
      fabric.Object.prototype.selectable = true;
      fabric.Object.prototype.evented = true;
      fabric.Object.prototype.pointerEvents = 'auto';
    })(canvas);


    let start = {
      x: 0,
      y: 0,
    };

    let clickTime = 0;

    this.ctx.on('mouse:down', (e) => {
      this.panning = true;
      clickTime = Date.now();
      start = e.absolutePointer;
    })

    this.ctx.on('mouse:up', (e) => {
      const pointer = e.absolutePointer;
      if (Date.now() - clickTime < 320 && pointer.x - start.x === 0 && pointer.y - start.y === 0) {
        const seat = e.target;
        if (seat) {
          if (seat.type === "group") {
            if (seat.isDisabled) return;
            let seatNumber = undefined;
            if (!seat.seatIsTake) {
              seatNumber = seat.seatNumber;
              this.clearChoose();
            }
            //判断选择的是否是禁用的数据
            if (this.options.disabledPosition.findIndex(val => val === seatNumber) > -1) {
              return;
            }
            Event.emit('onSeatClick', seatNumber);
            this.switchSeatStatus(seat);
          }
        }
      }
      this.panning = false;
    })

    let previousEvent = {}

    this.ctx.on('mouse:move', (e) => {
      if (this.panning) {
        const movement =  {
          x: e.absolutePointer.x - start.x,
          y: e.absolutePointer.y - start.y,
        }
        // console.log(movement);
        // console.log(this.fixedTop);
        // if (this.fixedTop <= 0 && movement.y < 0) {
        //   this.fixedTop += movement.y;
        // } else {
        //   movement.y = 0;
        //   console.log("增加内容!!!");
        //   this.fixedTop += movement.y;
        // }
        //
        // console.log("move = ", movement);

        const delta = new fabric.Point(0, movement.y);
        this.ctx.relativePan(delta);
      }
      previousEvent = e.absolutePointer;
    })
    this.render();
  }

  /**
   * 初始化座位数据数据
   */
  formatSeats() {
    for (let row = 0; row < this.options.seats.length; row++) {
      const seatsRow = this.options.seats[row];
      for (let index = 0; index < seatsRow.length; index++) {
        const seat = seatsRow[index]; // 对应得作为号码
        if (seat > 0) {
          const y = this.seatHeight * row + 20;
          const x = this.seatLength * index + 50;
          // this.drawSeat(x, y, seat);
        }
      }
    }
  }

  render() {
    // this.clearAll();
    this.drawSeats();
  }

  drawSeats() {
    for (let row = 0; row < this.options.seats.length; row++) {
      const seatsRow = this.options.seats[row];
      const columns = this.options.seats[row].length;
      const divideBySpace = (this.WIDTH - (this.offsetX * 2)) / columns;
      for (let index = 0; index < seatsRow.length; index++) {
        const seat = seatsRow[index]; // 对应得作为号码
        if (seat > 0) {
          let y = this.seatHeight * row;
          let x = divideBySpace * index + this.offsetX;
          if (this.options.disabledPosition.findIndex(val => val === seat) > -1) {
            this.drawSeat(x, y, seat, -1);
            continue;
          }
          this.drawSeat(x, y, seat, 0,);
        }
      }
    }
  }

  getStyleByType(type) {
    const tag = "" + type;
    const style = {
      fill: this.options.seatStyle.disabled,
      textColor: "#ffffff",
      icon: seatIcon,
      seatIsTake: true,
    };
     switch (tag) {
       case '-1':
         style.fill = this.options.seatStyle.disabled;
         style.icon = seatSelectIconPath;
         style.textColor = "#ffffff";
         style.seatIsTake = true;
         style.isDisabled = true;
         break;
       case '0':
         style.fill = this.options.seatStyle.inactive;
         style.icon = seatIconPath;
         style.textColor = "#999999";
         style.seatIsTake = false;
         break;
       case '1':
         style.fill = this.options.seatStyle.active;
         style.icon = seatSelectIconPath;
         style.textColor = "#ffffff";
         style.seatIsTake = true;
         break;
       case '2':
         style.fill = this.options.seatStyle.disabled;
         style.icon = seatSelectIconPath;
         style.textColor = "#ffffff";
         style.seatIsTake = true;
         break;
     }
     return style;
  }

  /**
   *
   * @param x 横坐标
   * @param y 纵坐标
   * @param value 座位的号码
   * @param type 座位状态, -1为禁用状态, 0 为可选状态, 1 为选中状态, 2 大座位
   * @param scaleWidth default = 30
   * @returns {*}
   */
  drawSeat(x, y, value, type, scaleWidth = 30) {
    const style = this.getStyleByType(type)
    const path = new fabric.Path(style.icon);
    if (this.type === 0 && value >= 61) {
      scaleWidth = 33;
    }
    path.set({
      fill: style.fill,
      left: 0,
      top: 0,
      originX: 'center',
      originY: 'center'
    });
    // path.scale(0.03);
    path.scaleToWidth(scaleWidth);
    path.hasControls = false;
    path.hasBorders = false;
    path.selectable = false;

    const text = new fabric.Text("" + value);
    text.hasControls = false;
    text.hasBorders = false;
    text.selectable = false;
    text.set({
      fill: style.textColor,
      fontSize: 14,
      originX: 'center',
      originY: 'center'
    });

    const seatGroup = new fabric.Group([path, text], {
      left: x,
      top: y,
    })
    seatGroup.hasControls = false;
    seatGroup.hasBorders = false;
    seatGroup.selectable = false;
    seatGroup.seatNumber = value; // 座位号码
    seatGroup.seatIsTake = style.seatIsTake; // 座位是否被占用
    seatGroup.isDisabled = style.isDisabled;

    this.ctx.add(seatGroup);
    return seatGroup;
  }


  switchSeatStatus(seat) {
    if (!seat.seatIsTake) {
      this.drawSeat(seat.left, seat.top, seat.seatNumber, 1);
    } else {
      this.drawSeat(seat.left, seat.top, seat.seatNumber, 0);
    }
    this.ctx.remove(seat);
    seat.seatIsTake = !seat.seatIsTake;
    this.ctx.renderAll();
  }

  clearAll() {
    this.ctx.clear();
  }

  clearChoose() {
    const allSeats = this.ctx.getObjects();
    for (const seat of allSeats) {
      if (seat.seatIsTake && !seat.isDisabled) {
        this.switchSeatStatus(seat);
      }
    }
  }

  updateDisabledSeats(seats)  {
    this.options.disabledPosition = seats;
    console.log('禁用的位置 = ', seats);
    const allSeats = this.ctx.getObjects();
    for (const seat of allSeats) {
      const { top, left, seatNumber: number } = seat;
      this.ctx.remove(seat);
      this.drawSeat(left, top, number, 0);
      if (this.options.disabledPosition.findIndex(val => val === number) > -1) {
        this.drawSeat(left, top, number, -1);
        this.ctx.renderAll(); // 刷新
      }
    }
  }
}

export default SeatsChart;
